function contentData() {
  return [
    {
      data: {
        sections: [
          {
            home: {
              banner: {
                element: {
                  align: "ob-left",
                  background: "light-blue",
                },
                media: {
                  mediaUrl: process.env.PUBLIC_URL + "/banner-1.mp4",
                  type: "video",
                  ratioType: "ratio-container-16-9",
                  additionalClass: "ob-banner-media",
                  bordered: true,
                },
                contentBlock: {
                  headingType: "h1",
                  align: "ob-left",
                  verticalCentered: true,
                  title: "Work<br> without<br> bounds.",
                  subtitle:
                    "Pods are an easy and cost-effective way to create more successful open-plan, collaborative and private workspaces.",
                },
              },
              general: {
                media: {
                  mediaUrl: process.env.PUBLIC_URL + "/about.jpg",
                  type: "image",
                  align: "ob-left",
                  alt: "Comfortable. Flexible. Accessible.",
                  bordered: true,
                },
                contentBlock: {
                  headingType: "h3",
                  align: "ob-right",
                  verticalCentered: false,
                  withPadding: true,
                  title: "Comfortable. Flexible. Accessible.",
                  subtitle:
                    "The workplace needs to be more comfortable, flexible and versatile than ever before. Offices with open floor plans need to be populated with workspaces, like pods, that offer accessible privacy—inviting places where you want to connect, collaborate and focus.",
                },
              },
              products: {
                product: [
                  {
                    background: "white",
                    id: "1",
                    productBanner: {
                      element: {
                        align: "ob-wide",
                        background: "light-blue",
                      },
                      media: {
                        mediaUrl: process.env.PUBLIC_URL + "/qt-1.mp4",
                        type: "video",
                        ratioType: "ratio-container-16-9",
                        align: "ob-wide",
                        bordered: true,
                      },
                      contentBlock: {
                        headingType: "h2",
                        align: "ob-wide",
                        verticalCentered: false,
                        title: "On the Qt",
                        subtitle:
                          "On the Qt phone booths strike the balance between the need for efficient space and workable comfort—so you can take a video call, carry out focused work or simply think for a while.",
                        button: {
                          text: "Explore On the Qt",
                          url: "https://www.steelcase.com/products/pods/on-the-qt/",
                        },
                      },
                    },
                    productContent: [
                      {
                        id: "1",
                        media: {
                          mediaUrl: process.env.PUBLIC_URL + "/qt-2.jpg",
                          type: "image",
                          align: "ob-left",
                          alt: "When you need a little privacy.",
                          bordered: true,
                          hotspot: {
                            horizonralDirection: "left",
                            horizonralValue: "44%",
                            verticalDirection: "top",
                            verticalValue: "24%",
                          },
                        },
                        contentBlock: {
                          headingType: "h2",
                          align: "ob-right",
                          verticalCentered: false,
                          withPadding: true,
                          title: "When you need a little privacy.",
                          subtitle:
                            "Innovative sound-blocking design ensures conversations remain discreet, while intuitive airflow and automatic lighting and ventilation make for a comfortable stay.",
                        },
                      },
                      {
                        id: "2",
                        media: {
                          mediaUrl: process.env.PUBLIC_URL + "/qt-3.png",
                          type: "image",
                          align: "ob-right",
                          alt: "Tell me about the “Kink.”",
                          bordered: false,
                          hotspot: {
                            horizonralDirection: "right",
                            horizonralValue: "31%",
                            verticalDirection: "top",
                            verticalValue: "26%",
                          },
                        },
                        contentBlock: {
                          background: "beige",
                          headingType: "h2",
                          align: "ob-left",
                          verticalCentered: true,
                          colored: true,
                          title: "Tell me about the “Kink.”",
                          subtitle:
                            "The angled—or “kinked”—air gap between  booths allows sound to bounce down and  away. When booths are facing the same  direction, users talk into the gap, reducing the amount of noise from booth to booth.",
                        },
                      },
                    ],
                  },
                  {
                    background: "page-bg",
                    id: "2",
                    productBanner: {
                      element: {
                        align: "ob-wide",
                        background: "white",
                      },
                      media: {
                        mediaUrl: process.env.PUBLIC_URL + "/air-1.mp4",
                        type: "video",
                        ratioType: "ratio-container-16-9",
                        align: "ob-wide",
                        bordered: true,
                      },
                      contentBlock: {
                        headingType: "h2",
                        align: "ob-wide",
                        verticalCentered: false,
                        title: "Air<sup>3</sup>",
                        subtitle:
                          "The perfect place to connect or concentrate, Air<sup>3</sup> is a safe, flexible, freestanding pod with a proprietary roof ventilation system unlike anything on the market. Air<sup>3</sup> can be easily assembled and customized to fit the needs of your space.",
                        button: {
                          text: "Explore Air<sup>3</sup",
                          url: "https://www.steelcase.com/products/pods/air3/",
                        },
                      },
                    },
                    productContent: [
                      {
                        id: "1",
                        media: {
                          mediaUrl: process.env.PUBLIC_URL + "/air-2.jpg",
                          type: "image",
                          align: "ob-right",
                          alt: "Patented Louvered Roof",
                          hotspot: {
                            horizonralDirection: "left",
                            horizonralValue: "38%",
                            verticalDirection: "top",
                            verticalValue: "4%",
                          },
                        },
                        contentBlock: {
                          headingType: "h2",
                          align: "ob-left",
                          verticalCentered: false,
                          withPadding: true,
                          bordered: true,
                          title: "Patented Louvered Roof",
                          subtitle:
                            "Our beautifully designed sound-blocking aluminum blades not only maximize acoustic performance and increase global compliance but they also go from closed to open in 20 seconds—increasing air flow and providing fresh air that works with the buildings existing air-conditioning system.   ",
                        },
                      },
                      {
                        id: "2",
                        media: {
                          mediaUrl: process.env.PUBLIC_URL + "/air-3.png",
                          type: "image",
                          align: "ob-left",
                          alt: "A Simple Solution",
                          bordered: false,
                          hotspot: {
                            horizonralDirection: "left",
                            horizonralValue: "24%",
                            verticalDirection: "top",
                            verticalValue: "32%",
                          },
                        },
                        contentBlock: {
                          background: "light-blue",
                          headingType: "h2",
                          align: "ob-right",
                          verticalCentered: true,
                          colored: true,
                          title: "Beautiful Design, Innovative Acoustics",
                          subtitle:
                            "Designed with both form and function in mind, Air<sup>3</sup> is not only beautiful, but is also customizable—choose from multiple colors, fabrics, and glass to make this pod your own. Plus, the combination of high-quality glass and soft acoustic paneling delivers a refined aesthetic and a high level of speech privacy.",
                        },
                      },
                    ],
                  },
                ],
              },
              tabs: {
                contentBlock: {
                  headingType: "h2",
                  align: "ob-wide",
                  verticalCentered: false,
                  title: "Which Size is Right For You?",
                  subtitle:
                    "Whether you need to take a quick call in private or hold a meeting with your team, there's a pod for that. Simply click through this size chart to see which pod size is the right fit.",
                  note: "Please note: All sizes are an estimation. Confirm exact specs with your dealer. Furniture pictured is to illustrate size only and must be purchased separately.",
                },
                tab: [
                  {
                    id: "1",
                    tabHeader: {
                      number: "01",
                      text: "Person",
                    },
                    tabContent: {
                      variants: [
                        {
                          id: "1",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL + "/models/qt-short-1.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "On the Qt Short",
                          },
                          headingType: "h3",
                          title: "On the Qt Short",
                          description:
                            "<p>Sit back and stay a while. Perfect for one, our smalest pod gets even more comfortable when paired with our lounge seat</p>",
                          qty: "1 Person",
                          size: "4' x 4' x 6'",
                          button: {
                            text: "Explore On the Qt",
                            url: "https://www.steelcase.com/products/pods/on-the-qt/",
                          },
                        },
                        {
                          id: "2",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL + "/models/qt-tall-1.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "On the Qt Tall",
                          },
                          headingType: "h3",
                          title: "On the Qt Tall",
                          description:
                            "<p>Pop in for a quick call. Designed for one, you can choose to add a work surface or stool for added comfort. </p>",
                          qty: "1 Person",
                          size: "4' x 4' x 7'",
                          button: {
                            text: "Explore On the Qt",
                            url: "https://www.steelcase.com/products/pods/on-the-qt/",
                          },
                        },
                        {
                          id: "3",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air23-1person.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air23",
                          },
                          headingType: "h3",
                          title: "Air23",
                          description:
                            "<p>A pod built for one or two, Air23 is cozy and versatile. Make it your own or share your space.  </p>",
                          qty: "1-2 People",
                          size: "6' x 9' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                        {
                          id: "4",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air25-1person.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air25",
                          },
                          headingType: "h3",
                          title: "Air25",
                          description:
                            "<p>Built with comfort, style, and versatility in mind, Air25 is the perfect pod for one, two, three, or four people. </p>",
                          qty: "1-4 People",
                          size: "10' x 9' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                      ],
                    },
                  },
                  {
                    id: "2",
                    tabHeader: {
                      number: "02",
                      text: "People",
                    },
                    tabContent: {
                      variants: [
                        {
                          id: "1",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air23-2person.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air23",
                          },
                          headingType: "h3",
                          title: "Air23",
                          description:
                            "<p>A pod built for one or two, Air23 is cozy and versatile. Make it your own or share your space. </p>",
                          qty: "1-2 People",
                          size: "6' x 9' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                        {
                          id: "2",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air25-2person.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air25",
                          },
                          headingType: "h3",
                          title: "Air25",
                          description:
                            "<p>Built with comfort, style, and versatility in mind, Air25 is the perfect pod for one, two, three, or four people. </p>",
                          qty: "1-4 People",
                          size: "10' x 9' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                      ],
                    },
                  },
                  {
                    id: "3",
                    tabHeader: {
                      number: "04",
                      text: "People",
                    },
                    tabContent: {
                      variants: [
                        {
                          id: "1",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air25-4people.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air25",
                          },
                          headingType: "h3",
                          title: "Air25",
                          description:
                            "<p>Built with comfort, style, and versatility in mind, Air25 is the perfect pod for one, two, three, or four people. </p>",
                          qty: "1-4 People",
                          size: "10' x 9' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                        {
                          id: "2",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air27-4people.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air27",
                          },
                          headingType: "h3",
                          title: "Air27",
                          description:
                            "<p>With room to spread out, Air27 is your dedicated project pod—and is perfect for up to six people. </p>",
                          qty: "4-6 People",
                          size: "9' x 15' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                      ],
                    },
                  },
                  {
                    id: "4",
                    tabHeader: {
                      number: "06",
                      text: "People",
                    },
                    tabContent: {
                      variants: [
                        {
                          id: "1",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air27-6people.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air27",
                          },
                          headingType: "h3",
                          title: "Air27",
                          description:
                            "<p>With room to spread out, Air27 is your dedicated project pod—and is perfect for up to six people. </p>",
                          qty: "4-6 People",
                          size: "9' x 15' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                        {
                          id: "2",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air29-6people.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air29",
                          },
                          headingType: "h3",
                          title: "Air29",
                          description:
                            "<p>Our largest pod is here to solve all your problems. Meet, collaborate or celebrate—there’s room for it all. </p>",
                          qty: "6-8 People",
                          size: "14' x 15' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                      ],
                    },
                  },
                  {
                    id: "5",
                    tabHeader: {
                      number: "08",
                      text: "People",
                    },
                    tabContent: {
                      variants: [
                        {
                          id: "1",
                          media: {
                            mediaUrl:
                              process.env.PUBLIC_URL +
                              "/models/air29-8people.png",
                            type: "image",
                            ratioType: "ratio-container-4-3",
                            alt: "Air29",
                          },
                          headingType: "h3",
                          title: "Air29",
                          description:
                            "<p>Our largest pod is here to solve all your problems. Meet, collaborate or celebrate—there’s room for it all. </p>",
                          qty: "6-8 People",
                          size: "14' x 15' x 8'",
                          button: {
                            text: "Explore Air<sup>3</sup>",
                            url: "https://www.steelcase.com/products/pods/air3/",
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  ];
}

export default contentData;
